import React from 'react';
import Icon from '../../../components/AppIcon';

const VirtualAccountBalance = ({ accountData, onResetBalance }) => {
  const { startingCapital, currentValue, unrealizedPnL, totalTrades, winRate } = accountData;
  const pnlPercentage = ((currentValue - startingCapital) / startingCapital) * 100;
  const isProfitable = unrealizedPnL >= 0;

  return (
    <div className="bg-card border border-border rounded-2xl p-6 trading-shadow">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
            <Icon name="Wallet" size={20} className="text-primary" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Virtual Account</h2>
            <p className="text-sm text-muted-foreground">Paper Trading Balance</p>
          </div>
        </div>
        {/* <button
          onClick={onResetBalance}
          className="px-4 py-2 bg-secondary hover:bg-secondary/80 text-secondary-foreground rounded-lg trading-transition flex items-center space-x-2"
        >
          <Icon name="RotateCcw" size={16} />
          <span>Reset</span>
        </button> */}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Starting Capital */}
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">Starting Capital</p>
          <p className="text-2xl font-bold text-foreground">${startingCapital?.toLocaleString()}</p>
        </div>

        {/* Current Value */}
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">Current Value</p>
          <div className="flex items-baseline space-x-2">
            <p className="text-2xl font-bold text-foreground">${currentValue?.toLocaleString()}</p>
            <span className={`text-sm font-medium ${
              pnlPercentage >= 0 ? 'text-success' : 'text-error'
            }`}>
              {pnlPercentage >= 0 ? '+' : ''}{pnlPercentage?.toFixed(2)}%
            </span>
          </div>
        </div>

        {/* Unrealized P&L */}
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">Unrealized P&L</p>
          <div className="flex items-center space-x-2">
            <p className={`text-2xl font-bold ${
              isProfitable ? 'text-success' : 'text-error'
            }`}>
              {isProfitable ? '+' : ''}${unrealizedPnL?.toLocaleString()}
            </p>
            <Icon 
              name={isProfitable ? "TrendingUp" : "TrendingDown"} 
              size={20} 
              className={isProfitable ? 'text-success' : 'text-error'} 
            />
          </div>
        </div>
      </div>
      {/* Additional Stats */}
      <div className="grid grid-cols-2 gap-4 mt-6 pt-6 border-t border-border-secondary">
        <div className="text-center">
          <p className="text-2xl font-bold text-foreground">{totalTrades}</p>
          <p className="text-sm text-muted-foreground">Total Trades</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-primary">{winRate}%</p>
          <p className="text-sm text-muted-foreground">Win Rate</p>
        </div>
      </div>
    </div>
  );
};

export default VirtualAccountBalance;